import styled from "styled-components";

export const Wrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 2fr;
  align-items: center;
  grid-row-gap: 2em;
  grid-column-gap: 2em;

  & > *:nth-child(2n + 1) {
    text-align: right;
  }
`;